import { MutationTuple, useMutation } from '@apollo/client';
import { MilestoneStatusInput, UnApproveFitupPayload } from '@bechtel/types';
import { UNAPPROVE_FITUP_MILESTONE } from '@bechtel/client-gql';

export function useUnapproveFitup(
  onCompleted: (data) => void,
  onError: (error) => void,
  refetchQueries: string[]
): //@ts-ignore type changed in @apollo/client
MutationTuple<{ unapproveFitup: UnApproveFitupPayload }, { input: MilestoneStatusInput }> {
  const response = useMutation<{ unapproveFitup: UnApproveFitupPayload }, { input: MilestoneStatusInput }>(
    UNAPPROVE_FITUP_MILESTONE,
    {
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        if (onCompleted) onCompleted(data);
      },
      onError: (error) => {
        if (onError) onError(error);
      },
      refetchQueries: refetchQueries,
    }
  );
  return response;
}
